import React from "react";
import { CloseBtnContainer, Container, MobileCloseBtn, NewsBox, Wrapper } from "./style";
import { useDispatch, useSelector } from "react-redux";
import { offNewsModal, selectActiveNewsModal, selectNewsModalData } from "redux/reducers/newsModalReducer";
const NewsModal = () => {
  const isActiveNewsModal = useSelector(selectActiveNewsModal);
  const newsModalData = useSelector(selectNewsModalData);
  const dispatch = useDispatch();
  const closeModalHandler = (e) => {
    if (e.target === e.currentTarget) dispatch(offNewsModal());
  };
  const closeBtnHandler = () => {
    dispatch(offNewsModal());
  };

  // 날짜 포맷팅
  function leftPad(value) {
    if (value >= 10) {
      return value;
    }

    return `0${value}`;
  }
  /**
   *
   * @param {Date} source
   * @param {String} delimiter
   * @returns
   */
  function toStringByFormatting(source, delimiter = ".") {
    const year = source.getFullYear();
    const month = leftPad(source.getMonth() + 1);
    const day = leftPad(source.getDate());

    return [year, month, day].join(delimiter);
  }

  /**
   *
   * @param {Date} source
   * @param {String} delimiter
   */
  function toStringByHourFormatting(source, delimiter = ":") {
    const hour = leftPad(source.getHours());
    const min = leftPad(source.getMinutes());

    return [hour, min].join(delimiter);
  }

  return (
    <>
      {isActiveNewsModal && newsModalData && (
        <Wrapper onClick={closeModalHandler}>
          <Container>
            <MobileCloseBtn>
              <img
                loading="lazy"
                src="https://sketch-htm-s3.s3.ap-northeast-2.amazonaws.com/file/6a904ef2News_close.svg"
                alt=""
                onClick={closeBtnHandler}
              />
            </MobileCloseBtn>
            <CloseBtnContainer>
              <img
                loading="lazy"
                onClick={closeBtnHandler}
                src="https://sketch-htm-s3.s3.ap-northeast-2.amazonaws.com/file/3725228dNews_Close.svg"
                alt="closeBtn"
              />
            </CloseBtnContainer>
            <NewsBox>
              <div>{newsModalData.title}</div>
              <div>
                <div>{toStringByFormatting(new Date(newsModalData.date))}</div>
                <div>
                  <img
                    loading="lazy"
                    src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
                    alt=""
                  />
                </div>
                <div>{toStringByHourFormatting(new Date(newsModalData.date))}</div>
                <div>
                  <img
                    loading="lazy"
                    src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
                    alt=""
                  />
                </div>
                <div>{newsModalData.region}</div>
              </div>
              <div>
                <img loading="lazy" src={newsModalData.img_path} alt="" />
              </div>
              <div dangerouslySetInnerHTML={{ __html: newsModalData.content }}></div>
            </NewsBox>
          </Container>
        </Wrapper>
      )}
    </>
  );
};

export default NewsModal;
